import { api } from "lib/graphql/api"
import { mutate } from "lib/graphql/mutate"
import { gql } from "@apollo/client"

export const deleteScenario = api(async function deleteScenario({ id }) {
    return mutate(
        gql`
            mutation DeleteScenario($id: String!) {
                deleteScenario(id: $id)
            }
        `,
        { id },
        { returns: "deleteScenario" }
    )
})
